<template>
  <div
    style="
      padding: 8px 6px 2px;
      background-color: rgb(241, 240, 240);
      border-radius: 10px;
      height: 100%;
    "
  >
    <div v-if="isEdit">
      <div class="form-control">
        <AutoresizeTextarea
          @input="onChangeMessage($event, 'message1')"
          :maxlength="640 - (value.message2.length + totalLength)"
          class="form-control"
          v-model="value.message1"
        ></AutoresizeTextarea>
      </div>
      <div>
        <div class="form-control" style="position: relative">
          <AutoresizeTextarea
            disabled
            :class="{ 'form-control': true, readonly: true }"
            value="{detail}"
          ></AutoresizeTextarea>
          <div style="position: absolute; right: 5px; top: -8px">
            <v-switch color="primary" v-model="value.detailstatus" small></v-switch>
          </div>
        </div>
      </div>
      <div>
        <div class="form-control" style="position: relative">
          <AutoresizeTextarea
            disabled
            :class="{ 'form-control': true, readonly: true }"
            value="{shipping}"
          ></AutoresizeTextarea>
          <div style="position: absolute; right: 5px; top: -8px">
            <v-switch color="primary" v-model="value.shippingstatus" small></v-switch>
          </div>
        </div>
      </div>
      <div class="form-control">
        <AutoresizeTextarea
          :maxlength="640 - (value.message1.length + totalLength)"
          class="form-control"
          v-model="value.message2"
        ></AutoresizeTextarea>
      </div>

      <div
        :class="{
          'text-xs-right': true,
          caption: true,
          'red--text': value.message1.length + value.message2.length > 640
        }"
      >
        {{ value.message1.length + value.message2.length }}/{{ 640 - totalLength }}
      </div>
    </div>
    <div v-else style="font-size: 12px">
      <div style="float: right">
        <v-btn @click="editPattern" small icon outline color="primary">
          <v-icon small>edit</v-icon>
        </v-btn>
      </div>
      <div class="pa-3">
        <nl2br
          :className="'wrapword'"
          style="word-break: break-word"
          tag="p"
          :text="value.message1"
        />
        <div v-if="value.detailstatus" class="my-2">
          Shirt (L): 100 Baht
          <br />----------------------------- <br />💰Total (not including shipping) 100 Baht
          <br />-----------------------------
        </div>

        <div v-if="value.shippingstatus" class="my-2">
          Shipping option
          <br />📦Thailand Post Free
          <br />
        </div>
        <nl2br tag="p" :text="value.message2" />
      </div>
    </div>
    <div v-if="isEdit" class="text-xs-center">
      <v-btn @click="cancelEditPattern" outline color="grey">{{ $t('cancel') }}</v-btn>
      <v-btn @click="onSave" :loading="updateloading" depressed color="primary">{{
        $t('save')
      }}</v-btn>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea.vue'
import specialtext from '@/components/elements/specialtext'
import nl2br from 'vue-nl2br'

export default {
  props: {
    value: {
      default: {
        message1: '',
        message2: '',
        detailstatus: false,
        shippingstatus: false
      }
    },
    type: {
      default: ''
    },
    patterntype: {
      default: 'setting'
    }
  },
  components: {
    AutoresizeTextarea,
    specialtext,
    nl2br
  },
  data() {
    return {
      isEdit: false,
      temppattern: '',
      updateloading: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    totalLength() {
      var a = 0
      var b = 0
      if (this.value.detailstatus) a = 100
      if (this.value.shippingstatus) b = 100
      return a + b
    }
  },
  methods: {
    onChangeMessage(e, message) {
      this.value[message] = e.slice(0, 640 - this.totalLength)
    },
    onSave() {
      if (this.value.message1.length + this.value.message2.length <= 640 - this.totalLength) {
        if (this.patterntype == 'setting') {
          this.putcartsummarypattern()
        } else if (this.patterntype == 'products') {
          this.isEdit = false
          this.$emit('onSave')
        }
      }
    },
    putcartsummarypattern(pattern, shippingstatus, type) {
      this.updateloading = true
      var data = {
        pageid: this.selectedBot.pageid,
        pattern: JSON.stringify(this.value),
        type: this.type,
        shippingpattern_status: true
      }
      api.putcartsummarypattern(data, (err, response) => {
        this.updateloading = false
        this.isEdit = false
      })
    },
    editPattern() {
      this.temppattern = JSON.stringify(this.value)
      this.isEdit = true
    },
    cancelEditPattern() {
      this.$emit('input', JSON.parse(this.temppattern))
      //   this.value =
      this.isEdit = false
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapword {
  word-break: break-word;
}
.readonly {
  background-color: #f3f3f3;
}
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
p {
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/view/live/MessageItem.vue